module.exports = __webpack_public_path__ + "static/media/strengthTitle.6f2ec87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/strengthTitle.png
// module id = 449
// module chunks = 0